const endpoints = {
  GET_SESSION: '/v2/ccp/me/getAgentInfo',
  LOGIN: '/v2/ccp/logIn',
  LOGOUT: '/v2/ccp/logout',
}

export class Auth {

  constructor({ requester }) {
    this.requester = requester
    this.endpoints = endpoints
  }

  async fetchCurrentUser(opts) {
    return this.requester.get(endpoints.GET_SESSION, {}, opts)
  }

  async login({ email, password }, opts = {}) {
    return this.requester.post(endpoints.LOGIN, { email, password }, { useAuth: false, ...opts })
  }

  async logout(opts) {
    return this.requester.post(endpoints.LOGOUT, {}, opts)
  }
}
